import apiClient from './apiClient';

const gmailService = {
    // OAuth (admin)
    getAuthUrl: () => apiClient.get('/gmail/admin/auth-url'),

    // Cuentas conectadas (admin)
    getCuentas: () => apiClient.get('/gmail/admin/cuentas'),
    desconectarCuenta: (idCredencial) => apiClient.delete(`/gmail/admin/cuentas/${idCredencial}`),

    // Suscriptores de una cuenta (admin)
    getSuscripciones: (idCredencial) => apiClient.get(`/gmail/admin/cuentas/${idCredencial}/suscripciones`),
    suscribir: (idCredencial, idUsuario) => apiClient.post(`/gmail/admin/cuentas/${idCredencial}/suscripciones/${idUsuario}`),
    desuscribir: (idCredencial, idUsuario) => apiClient.delete(`/gmail/admin/cuentas/${idCredencial}/suscripciones/${idUsuario}`),

    // Filtros por suscripción (admin)
    getFiltrosSuscripcion: (idCredencial, idSuscripcion) =>
        apiClient.get(`/gmail/admin/cuentas/${idCredencial}/suscripciones/${idSuscripcion}/filtros`),
    agregarFiltroSuscripcion: (idCredencial, idSuscripcion, tipo, valor) =>
        apiClient.post(`/gmail/admin/cuentas/${idCredencial}/suscripciones/${idSuscripcion}/filtros`, { tipo, valor }),
    eliminarFiltroSuscripcion: (idCredencial, idSuscripcion, idFiltro) =>
        apiClient.delete(`/gmail/admin/cuentas/${idCredencial}/suscripciones/${idSuscripcion}/filtros/${idFiltro}`),

    // Polling manual (admin)
    consultarAhora: () => apiClient.post('/gmail/admin/consultar-ahora'),

    // Autoservicio (cualquier usuario autenticado)
    getMiAuthUrl: () => apiClient.get('/gmail/mi-cuenta/auth-url'),
    getMisSuscripciones: () => apiClient.get('/gmail/mi-cuenta/suscripciones'),
    getMisFiltros: (idSuscripcion) => apiClient.get(`/gmail/mi-cuenta/suscripciones/${idSuscripcion}/filtros`),
    agregarMiFiltro: (idSuscripcion, tipo, valor) =>
        apiClient.post(`/gmail/mi-cuenta/suscripciones/${idSuscripcion}/filtros`, { tipo, valor }),
    eliminarMiFiltro: (idSuscripcion, idFiltro) =>
        apiClient.delete(`/gmail/mi-cuenta/suscripciones/${idSuscripcion}/filtros/${idFiltro}`),
};

export default gmailService;
